<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="dedication" role="doc-dedication">
<p class="ded1"><span aria-label="page 5" epub:type="pagebreak" id="page_5" role="doc-pagebreak"><i>To all of my teachers:your knowledge and embodied wisdom are the backbone of this book.</i></span></p>
<p class="ded2">~</p>
<p class="ded3"><i>To that place within each of us that knows the way home.</i></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?5bfdab14